import { TablePagination, useEventCallback } from '@mui/material';
import DataGridPaginationAction from './DataGridPaginationAction';
import TableLabelDisplayedRows from './TableLabelDisplayedRows';

const DataGridPagination = function BasePagination({ ref, ...props }) {
  const { onRowsPerPageChange, showFullPagination = true, rowsPerPageOptions, ...rest } = props;

  return (
    <TablePagination
      {...rest}
      showFirstButton
      showLastButton
      component="div"
      rowsPerPageOptions={[5, 10, 20]}
      ActionsComponent={(props) => (
        <DataGridPaginationAction
          showFullPagination={showFullPagination}
          // showAllHref={showAllHref}
          {...props}
        />
      )}
      onRowsPerPageChange={useEventCallback((event) => {
        onRowsPerPageChange?.(event);
      })}
      // onRowsPerPageChange={useEventCallback((event) => {
      //   onRowsPerPageChange?.(Number(event.target.value));
      // })}
      labelDisplayedRows={TableLabelDisplayedRows}
      ref={ref}
    />
  );
};

export default DataGridPagination;
